import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface JournalisationTypeOperationSelectProps {
    setTypeOperation: (typeOperation: string) => void;
    selectedTypeOperation: string | null;
}

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const JournalisationTypeOperationSelect: React.FC<JournalisationTypeOperationSelectProps> = ({ setTypeOperation, selectedTypeOperation }) => {
    const statuts: string[] = ['Connexion', 'Livraison Client'];

    const options: ISelectOption[] = statuts.map((statut) => ({
        value: statut,
        label: statut,
    }));

    const selectedOption = options.find((option) => option.value === selectedTypeOperation) || null;

    const handleChange = (selectedOption: ISelectOption | null) => {
        setTypeOperation(selectedOption ? selectedOption.value : 'Connexion');
    };

    return <Select id="autoSizingSelect" value={selectedOption} options={options} onChange={handleChange} placeholder={'--- Type opération'} styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default JournalisationTypeOperationSelect;
